import { render } from "./TeacherAppointmentDataTable.vue?vue&type=template&id=09b76dae&scoped=true"
import script from "./TeacherAppointmentDataTable.vue?vue&type=script&lang=js"
export * from "./TeacherAppointmentDataTable.vue?vue&type=script&lang=js"

import "./TeacherAppointmentDataTable.vue?vue&type=style&index=0&id=09b76dae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09b76dae"]])

export default __exports__